import React, { Component } from 'react'
import { StaticQuery, graphql} from 'gatsby'

import Col from 'react-bootstrap/Col'

import CourseMenuChapter from '../course-menu-chapter'

import '../course-menu.scss'


const CourseSelectionMenu = class extends Component {
  constructor(props) {
    super(props)
    this.state = {
      active_url: '/'
    }
  }

  componentDidMount() {
    this.setActiveUrl()
  }

  setActiveUrl = () => {
    try {
      this.setState({active_url: window.location.href})
    } catch (error) {
      console.log(error)
    }
  }

  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            allCourseSelectionMenuJson {
              edges {
                node {
                  title
                  url
                  urlTitle
                  external
                  additionalUrls {
                    urlTitle
                    url
                    external
                  }
                }
              }
            }
          }
        `}
        render={data => (
          <Col
            xs={12}
            sm={4}
            md={3}
            lg={2}
            id="course-menu"
            className="pt-4"
          >
            {data.allCourseSelectionMenuJson.edges.map((chapter, index) => {
              return (
                <CourseMenuChapter
                  active_url={this.state.active_url}
                  chapter={chapter}
                  key={`chapter-${index + 1}`}
                ></CourseMenuChapter>
              )
            })}
          </Col>
        )}
      />
    )
  }
}

export default CourseSelectionMenu